import axios, { AxiosPromise } from 'axios';
import { IGetPosPartialRefundTempTodo } from '../models/niceRefund.model';
import {
  IGetPaymentRefunds,
  IGetRefundStats,
  IPaymentRefundParams,
  IRefundStatsParams,
} from '../models/niceRefunds.model';
import QueryString from 'qs';

const uri = '/mgmt/nice-refunds';


export const niceRefundOrder = (refundNo: number): AxiosPromise => {
  return axios.post(`${uri}/todo/${refundNo}`);
};

export const adminRefundOrder = (
  refundNo: number,
  reasonCode: string,
): AxiosPromise => {
  return axios.post(`${uri}/admin-todo/${refundNo}`, { reasonCode });
};

export const adminRefundCancel = (
  refundNo: number,
): AxiosPromise => {
  return axios.post(`${uri}/cancel/${refundNo}`);
};


export const cancelPosResult = (body: any, refundNo: number): AxiosPromise => {
  return axios.post(`${uri}/result/${refundNo}`, body);
};

export const createPosPartialRefundTempTodo = (refundNo: number): AxiosPromise<IGetPosPartialRefundTempTodo> => {
  return axios.post(`${uri}/temp-todo/${refundNo}`);
};

export const approvePosPartialRefundTempTodo = (body: any): AxiosPromise => {
  return axios.post(`${uri}/temp-change`, body);
};

export const cancellationOfApprovalPosResult = (body: any): AxiosPromise => {
  return axios.post(`${uri}/approval-cancel`, body);
};

export const getPaymentRefunds = (
  params: IPaymentRefundParams,
): AxiosPromise<IGetPaymentRefunds> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/list?${qsParams}`);
};

export const getRefundStats = (
  params: IRefundStatsParams,
): AxiosPromise<IGetRefundStats> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/tuition?${qsParams}`);
};